import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmployeesResponse, vacationsScheduleApi } from 'app/services/edpApiV1/vacationsSchedule';
import { RootState } from 'app/store';

const initialState = {
  data: [
    {
      id: 0,
      personnelNumber: '',
      name: '',
      lastName: '',
      middleName: '',
      position: '',
      division: '',
      scheduleRequests: [
        {
          id: 0,
          status: { name: '', type: 'draft' },
          zupRequestStatus: null,
          comment: null,
          startedAt: '',
          endedAt: '',
          amountDays: 0,
          vacationType: {
            id: '',
            name: '',
          },
        },
      ],
    },
  ],
  pagination: {
    size: 0,
    page: 0,
    total: 0,
  },
} as EmployeesResponse;

export const getEmployeesScheduleSlice = createSlice({
  name: 'getEmployeesSchedule',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        vacationsScheduleApi.endpoints.getEmployeesSchedule.matchFulfilled,
        (state, { payload }: PayloadAction<EmployeesResponse>) => payload,
      )
      .addMatcher(vacationsScheduleApi.endpoints.getEmployeesSchedule.matchRejected, () => initialState);
  },
});

const employeesSchedule = (state: RootState) => state.entities.vacationsSchedule.employeesSchedule;
const getEmployeesSchedule = createSelector(employeesSchedule, state => state);
const employeesSchedulePagination = createSelector(employeesSchedule, ({ pagination }) => pagination);

export const selectors = { getEmployeesSchedule, employeesSchedulePagination };
export const actions = getEmployeesScheduleSlice.actions;
export const reducer = getEmployeesScheduleSlice.reducer;
